<template>
  <div id="raports_table">
    <a-form layout="inline" :form="form" @submit="handleSubmit">
      <a-form-item>
        <!-- @change="(e) => handlerChangeCompanies(e, 'mainCompanies')" -->
        <a-select
          mode="multiple"
          style="min-width: 200px"
          showSearch
          allowClear
          optionFilterProp="children"
          v-decorator="[
            'mainCompanies',
            { rules: [{ required: false }], initialValue: [] },
          ]"
          :placeholder="$t('Main Company')"
        >
          <a-select-option v-for="(comp, id) in MY_COMPANY_LIST" :key="id">{{
            comp.TITLE
          }}</a-select-option>
        </a-select>
      </a-form-item>
      <!-- @change="(e) => handlerChangeCompanies(e, 'Contractors')" -->
      <a-form-item>
        <a-input
          :placeholder="$t('Contractor')"
          @click="handleChangeContractor()"
          v-model="contactorTitle"
        />
      </a-form-item>
      <a-form-item hidden>
        <a-select
          mode="multiple"
          style="min-width: 200px"
          showSearch
          allowClear
          optionFilterProp="children"
          v-decorator="[
            'Contractors',
            { rules: [{ required: false }], initialValue: [] },
          ]"
          :placeholder="$t('Contractor')"
        >
          <a-select-option v-for="(comp, id) in COMPANY_LIST" :key="id">{{
            comp.TITLE
          }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-select
          mode="multiple"
          style="min-width: 200px"
          showSearch
          allowClear
          optionFilterProp="children"
          v-decorator="[
            'Deals',
            { rules: [{ required: false }], initialValue: [] },
          ]"
          :placeholder="$t('Deals')"
        >
          <a-select-option v-for="(deal, id) in NeedDeals" :key="id">{{
            deal.TITLE + " (" + deal.ID + ")"
          }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-select
          mode="multiple"
          style="min-width: 200px"
          showSearch
          allowClear
          optionFilterProp="children"
          v-decorator="[
            'Categories',
            { rules: [{ required: false }], initialValue: [] },
          ]"
          :placeholder="$t('Categories')"
        >
          <a-select-option v-for="(item, id) in Categories" :key="id">{{
            item.NAME
          }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-range-picker
          v-decorator="[
            'Dates',
            {
              rules: [{ type: 'array', required: false }],
              initialValue: [],
            },
          ]"
        />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" html-type="submit">{{
          $t("Search")
        }}</a-button>
      </a-form-item>
    </a-form>
    <a-table
      v-if="tableKey"
      :columns="columns"
      :data-source="Reports"
      @expand="handlerExpand"
      bordered
      tableLayout="auto"
      :scroll="{ x: true }"
      :key="tableKey"
      size="middle"
      :pagination="{
        pageSize: 30,
        'show-size-changer': true,
        showTotal: (total) => `${this.$t('Total')} ${total}`,
      }"
    >
      <template slot="budget" slot-scope="text, record">
        <div>
          <div v-if="dealFindBudget[record.deal]">
            <div v-if="dealFindBudget[record.deal].amountNet > 0">
              <div
                v-if="
                  dealFindBudget[record.deal].amountNet >=
                  record.brutto.invoices
                "
              >
                <a-tag @click="goToBudget(record.deal)" color="green">{{
                  Number(dealFindBudget[record.deal].amountNet).toFixed(2)
                }}</a-tag>
              </div>
              <div v-else>
                <a-tag @click="goToBudget(record.deal)" color="red">{{
                  Number(dealFindBudget[record.deal].amountNet).toFixed(2)
                }}</a-tag>
              </div>
            </div>
          </div>
        </div>
      </template>
    </a-table>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { filterIncomeStatement, getBudget } from "@/requestFunc";

export default {
  props: ["costTypes", "COMPANY_LIST", "MY_COMPANY_LIST", "DEAL_LIST"],
  computed: mapGetters(["Reports", "NeedDeals", "Categories"]),
  data() {
    return {
      form: this.$form.createForm(this, { name: "filter_form" }),
      CACHE_DEAL_LIST: {},
      tableKey: 0,
      budget: [],
      contactorTitle: "",
      dealFindBudget: {},
      columns: [
        {
          title: this.$t("Deals"),
          dataIndex: "title",
          customRender: (text, record) =>
            "deal" in record ? (
              <a
                href={`https://24.anteo.pl/crm/deal/details/${record.deal}/`}
                target="_blank"
              >
                <a-tag color="#2db7f5">{{ text }}</a-tag>
              </a>
            ) : (
              <a-tag color="purple">{{ text }}</a-tag>
            ),
        },
        {
          title: this.$t("Categories"),
          dataIndex: "category",
          customRender: (text, record) => {
            if (this.Categories[text]) {
              if ("NAME" in this.Categories[text]) {
                return (
                  "category" in record && (
                    <a-tag color="#38A49F">{this.Categories[text].NAME}</a-tag>
                  )
                );
              } else {
                return "";
              }
            } else {
              return "";
            }
          },
        },
        {
          title: this.$t("FV Kosztowe"),
          dataIndex: "brutto.invoices",
          sorter: (a, b) => a.brutto.invoices - b.brutto.invoices,
          customRender: (text, record) =>
            "deal" in record ? (
              <a-tag color="#f50">{text.toFixed(2)}</a-tag>
            ) : (
              <a-tag color="volcano">{text.toFixed(2)}</a-tag>
            ),
        },
        {
          title: this.$t("FV Sprzedażowe"),
          dataIndex: "brutto.sales",
          sorter: (a, b) => a.brutto.sales - b.brutto.sales,
          customRender: (text, record) =>
            "deal" in record ? (
              <a-tag color="#87d068">{text.toFixed(2)}</a-tag>
            ) : (
              <a-tag color="green">{text.toFixed(2)}</a-tag>
            ),
        },
        /*{
      title: this.$t(" Budżet"),
      dataIndex: "budget",
      scopedSlots: {customRender: "budget"},
      sorter: (a, b) => a.budget - b.budget,
    },*/
        {
          title: this.$t("TotalSumm"),
          dataIndex: "brutto.total",
          sorter: (a, b) => a.brutto.total - b.brutto.total,
          customRender: (text, record) =>
            "deal" in record ? (
              <a-tag color="#108ee9">{text.toFixed(2)}</a-tag>
            ) : (
              <a-tag color="blue">{text.toFixed(2)}</a-tag>
            ),
        },
      ],
    };
  },
  methods: {
    ...mapActions(["getReports"]),
    ...mapMutations(["setReports", "UPDATE_FILTER_BUDGET"]),
    handlerExpand() {
      this.$emit("resizeFrame");
    },
    handleChangeContractor() {
      BX24.selectCRM(
        {
          entityType: ["company"],
          multiple: true,
        },
        (info) => {
          let arrayCompanyName = [];
          let arrayCompanyID = [];
          for (let name in info.company) {
            arrayCompanyName.push(info.company[name].title);
            arrayCompanyID.push(info.company[name].id.split("_")[1]);
          }
          this.contactorTitle = arrayCompanyName.join();
          this.form.setFieldsValue({
            Contractors: arrayCompanyID,
          });
        }
      );
    },
    // handlerChangeCompanies(val, type) {
    //   let values = this.form.getFieldsValue();
    //   values[type] = val;
    //   var deals = [];
    //   if (values.mainCompanies.length) {
    //     deals = this.Deals.filter(
    //       (deal) =>
    //         deal[1].main.filter((comp) => values.mainCompanies.includes(comp))
    //           .length
    //     );
    //   }
    //   if (values.Contractors.length) {
    //     deals = this.Deals.filter(
    //       (deal) =>
    //         deal[1].contractor.filter((comp) =>
    //           values.Contractors.includes(comp)
    //         ).length
    //     );
    //   }
    //   deals = deals.map((x) => x[0]);
    //   if (values.Contractors.length || values.mainCompanies.length) {
    //     this.CACHE_DEAL_LIST = Object.assign(
    //       {},
    //       Object.fromEntries(
    //         Object.entries(this.NeedDeals).filter((x) =>
    //           deals.includes(x[0])
    //         )
    //       )
    //     );
    //   } else {
    //     this.DEAL_LIST = Object.assign({}, this.CACHE_DEAL_LIST);
    //   }
    // },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.changeSpinning(true);
          values.Dates = values.Dates.map((x) =>
            x.format("YYYY-MM-DD hh:mm:ss")
          );
          filterIncomeStatement(values)
            .done((data) => {
              let result = JSON.parse(data);

              this.setReports(result.file);
              this.tableKey++;
              this.$message.success("Filter completed");
            })
            .fail((e) => {
              console.err(e);
              this.$message.error(this.$t("Error filter"));
            })
            .always(() => {
              this.changeSpinning(false);
              this.$emit("resizeFrame");
            });
        } else {
          this.$notification.success({
            message: this.$t("Filter fields error "),
          });
        }
      });
    },
    changeSpinning(val) {
      this.$emit("changeSpinning", val);
    },
    downloadBudget() {
      let budget;
      getBudget()
        .done((data) => {
          this.$message.info(this.$t("Download complete!"));
          let item = data == "" ? {} : JSON.parse(data);

          if (Array.isArray(item)) {
            budget = item;
            let resultBudget = budget.map((el, key) => {
              this.dealFindBudget[el.PROPERTY_VALUES.deal] = {
                key,
                id: el.ID,
                nameBudget: el.PROPERTY_VALUES.nameBudget,
                deal: el.PROPERTY_VALUES.deal,
                positions: 0,
                amountNet: el.PROPERTY_VALUES.amountNet,
              };
              return {
                key,
                id: el.ID,
                nameBudget: el.PROPERTY_VALUES.nameBudget,
                deal: el.PROPERTY_VALUES.deal,
                positions: 0,
                amountNet: el.PROPERTY_VALUES.amountNet,
              };
            });
            this.budget = resultBudget;
          }
        })
        .fail((e) => {
          console.err(e);
          this.$message.error(this.$t("Error loading document"));
        });
    },
    goToBudget(deal) {
      let filter = {
        idDeal: deal,
      };
      this.UPDATE_FILTER_BUDGET(filter);

      this.$emit("goToBudget");
    },
    getdeal() {
      var deals = [];
      BX24.callMethod("crm.deal.list", {}, (result) => {
        if (result.error()) console.error(result.error());
        else {
          //console.log(result.data());
          deals = deals.concat(result.data());
          if (result.more()) {
            result.next();
          } else {
            let dealsWithKey = [];
            for (let deal of deals) {
              dealsWithKey[deal.ID] = deal;
            }
            this.getReports(dealsWithKey);
          }
        }
      });
    },
  },
  async mounted() {
    this.getdeal();
    this.changeSpinning(true);
    await this.downloadBudget();
    //await this.getReports(this.DEAL_LIST);
    this.tableKey++;
    this.changeSpinning(false);
    this.$emit("resizeFrame");
  },
};
</script>

<style>
</style>
